import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { encryptId } from "../services/apiService";

const useHandleNavigation = () => {
    const navigate = useNavigate();

    const handleNavigation = (userData) => {
        console.log("userData handleNavigation", userData);

        // Validate userData
        if (!userData || !userData.user_type) {
            console.error("Invalid userData provided to handleNavigation");
            toast.error("Invalid user data. Please try logging in again.");
            navigate("/");
            return;
        }

        setTimeout(() => {
            const userType = userData.user_type?.toLowerCase();

            switch (userType) {
                case "administrator":
                case "admin":
                    navigate("/superadmin/dashboard");
                    break;
                case "doctors":
                case "doctor":
                    if (userData.id) {
                        navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    } else {
                        console.error("Doctor ID missing for navigation");
                        navigate("/doctor/dashboard");
                    }
                    break;
                case "staff":
                    navigate("/superadmin/dashboard");
                    break;
                case "hospitals":
                case "hospital":
                    navigate("/hospital/dashboard");
                    break;
                case "regular_users":
                case "patient":
                    navigate("/user-dashboard");
                    break;
                case "pharmacy":
                    navigate("/pharmacy/dashboard");
                    break;
                case "user":
                    navigate("/user-dashboard");
                    break;
                case "editor":
                    navigate("/editor-dashboard");
                    break;
                default:
                    console.warn(`Unknown user type: ${userType}. Redirecting to home page.`);
                    // For unknown roles, stay on home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    return handleNavigation;
};

export default useHandleNavigation;
